import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Row, Container, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import Layout from "../../layout/default";

const HrDashboard = () => {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      Swal.fire({
        icon: "warning",
        title: "Authentication Required",
        text: "Please log in to proceed.",
      }).then(() => {
        navigate("/shop/auths/login", { replace: true });
      });
    }
  }, [navigate]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    const authToken = localStorage.getItem("authToken");

    // Show Swal with 5s timer and custom loading image
    // Swal.fire({
    //   title: 'Loading...',
    //   imageUrl: '/shop/images/Loading-time.svg',
    //   imageWidth:  '100%',
    //   imageHeight:'auto',
    //   imageAlt: 'Loading',
    //   showConfirmButton: false,
    //   allowOutsideClick: false,
    //   allowEscapeKey: false,
    //   backdrop: true,
    //   timer: 2000, // Show for 5 seconds
    //   timerProgressBar: true,
    // });

    axios.get(`${process.env.REACT_APP_HOST}api/combo-categories`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then((response) => {
        setCategories(response.data.data);
        // ❌ Don't close Swal manually if you want timer to finish naturally
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        Swal.fire({
          imageUrl: "/shop/images/Failed_1.svg", // Replace with your image path
          imageWidth: 100,
          imageHeight: 100,
          imageAlt: "Error Image",
          text: 'Failed to load categories.',
        });
      });
  };

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearch(query);

    if (query.trim() === '') {
      setResults([]);
      setShowDropdown(false);
      return;
    }

    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(`${process.env.REACT_APP_HOST}api/combo-search`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { search: query },
      });

      if (response.data.success) {
        setResults(response.data.data.slice(0, 10));
        setShowDropdown(true);
      }
    } catch (error) {
      console.error('Search error:', error);
    }
  };

  const handleSelect = (id) => {
    setSearch('');
    setResults([]);
    setShowDropdown(false);
    navigate(`/shop/combo/${id}`);
  };

  return (
    <Layout title="Welcome">
      <Container fluid className="mt-4">
        <Row className="justify-content-center">
          <Col xs={12} lg={19} className="text-center">
            <h2 className="section__title title-animation text-capitalize rr-br-hidden-md mb-1" data-cursor="-opaque">Categories</h2>

            {categories.length === 0 ? (
              <div className="text-center py-5">
                <p className="mt-2">Loading categories...</p>
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Row className="gx-3 gy-4 justify-content-center">
                {categories.map((category) => (
                  <Col lg={4} md={6} xs={12} key={category.id} className="d-flex justify-content-center">
                    <Card
                      className="h-100 border-0"
                      style={{
                        width: '100%',
                        maxWidth: '430px',
                        height: window.innerWidth < 768 ? '200px' : '306px',
                        overflow: 'hidden'
                      }}
                    >
                      <a
                        href={`/shop/combos/${category.id}`}
                        className="text-decoration-none position-relative"
                      >
                        <Card.Img
                          src={`${process.env.REACT_APP_HOST}storage/${category.image_url}`}
                          alt={category.name}
                          className="card-img-top"
                          style={{
                            width: '100%',
                            height: window.innerWidth < 768 ? '200px' : '306px',
                            objectFit: 'cover'
                          }}
                        />
                        <div
                          className="icon__wrapper position-absolute"
                          style={{
                            top: '10px',
                            right: '10px',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            zIndex: 2
                          }}
                        >
                          <div className="icon"></div>
                        </div>
                        <Card.Body
                          className="p-3 position-absolute bottom-0 start-0 w-100"
                          style={{
                            transform: 'translateY(100%)',
                            transition: 'all 0.3s',
                            backgroundColor: '#15181B',
                            zIndex: 2,
                            padding: window.innerWidth < 768 ? '10px' : '20px'
                          }}
                        >
                          <Card.Title
                            style={{
                              fontSize: window.innerWidth < 768 ? "18px" : "25px"
                            }}
                            className="text-white"
                          >
                            {category.name}
                          </Card.Title>
                        </Card.Body>
                        <div
                          className="position-absolute w-100 h-100 top-0 start-0"
                          style={{
                            backgroundColor: '#15181B',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            zIndex: 1
                          }}
                        ></div>
                      </a>
                    </Card>
                    <style jsx>{`
                      .card:hover .icon__wrapper {
                        opacity: 1 !important;
                      }
                      .card:hover .card-body {
                        transform: translateY(0) !important;
                      }
                      .card:hover .position-absolute[style*="opacity: 0"] {
                        opacity: 0.8 !important;
                      }
                      .card:hover img {
                        transform: scale(1.05);
                      }
                      @media (max-width: 767.98px) {
                        .card {
                          height: 200px !important;
                        }
                        .card img {
                          height: 200px !important;
                        }
                      }
                    `}</style>
                  </Col>
                ))}
              </Row>
            )}
          </Col>
        </Row>
      </Container>
      <br /><br /><br /><br />
    </Layout>
  );
};

export default HrDashboard;
